import * as t from 'io-ts';
import {isArray, isString} from 'lodash';

import {hasProperty} from '../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {isExpressionRef} from '../expressions/expressionRefModel';
import {RRegexPart, RStringOrTemplate, RStringTemplate, RStringTemplatePart} from '../expressions/iotsCodecs';

/*
 * Regex part.
 */

export enum RegexCharacterClassesEnum {
  DIGIT = 'digit',
  ALPHA = 'alpha',
  ALPHA_DIGIT = 'alpha_digit',
  WORD = 'word',
  PRINTABLE = 'printable',
  ANY = 'any',
  WORD_BOUNDARY = 'word_boundary',
}

export const MAX_REGEX_PART_REPEAT = 5;

export interface RegexPart extends t.TypeOf<typeof RRegexPart> {}

export function isRegexPart(value: unknown): value is RegexPart {
  return Boolean(hasProperty(value, 'char') && isString(value.char));
}

export function hasRegexDisclosure(value: RegexPart) {
  return value.char !== RegexCharacterClassesEnum.WORD_BOUNDARY;
}

/*
 * String template.
 */

export type StringTemplatePart = t.TypeOf<typeof RStringTemplatePart>;

export interface StringTemplate extends t.TypeOf<typeof RStringTemplate> {}

export function isTemplatePart(value: unknown): value is StringTemplatePart {
  return isString(value) || isExpressionRef(value) || isRegexPart(value);
}

export function isStringTemplate(value: unknown): value is StringTemplate {
  return Boolean(
    hasProperty(value, 'template') && isArray(value.template) && value.template.every(isTemplatePart),
  );
}

export type StringOrTemplate = t.TypeOf<typeof RStringOrTemplate>;

export function isStringOrTemplate(value: unknown): value is StringOrTemplate {
  return isString(value) || isStringTemplate(value);
}
